import { useQuery, useMutation, useQueryClient } from "react-query";
import {
	getLookupsPhenologicalState,
	getPhenologicalStateById,
	getPhenologicalState,
	savePhenologicalState,
	deletePhenologicalState,
} from "@/api/Maintainers/OA/oa-phenological-state-api.js";

export const key = "phenological-state";

export function usePhenologicalStateLookups(enabled = true) {
	return useQuery([key, "lookups"], () => getLookupsPhenologicalState(), { enabled });
}

export function usePhenologicalState(filters, enabled = true) {
	return useQuery([key, "list", filters], () => getPhenologicalState(filters), { enabled });
}

export function usePhenologicalStateById(filters, id_element, enabled) {
	return useQuery([key, "detail", filters, id_element], () => getPhenologicalStateById(filters, id_element), {
		enabled: enabled,
		keepPreviousData: true,
	});
}

export function useSavePhenologicalState() {
	const queryClient = useQueryClient();

	return useMutation(savePhenologicalState, {
		onSuccess: () => {
			queryClient.invalidateQueries([key, "list"]);
		},
	});
}

export function useDeletePhenologicalState() {
	const queryClient = useQueryClient();

	return useMutation(deletePhenologicalState, {
		onSuccess: () => {
			queryClient.invalidateQueries([key, "list"]);
		},
	});
}
